import { gql } from 'apollo-angular';

export const onPublisExternalDeviceStatusSubscription = gql`
  subscription onCreateExternalSystemStatusItem($accountId: String!) {
    onCreateExternalSystemStatusItem(accountId: $accountId) {
      accountId
      description
      currentState {
        status
        timestamp
      }
      previousState {
        status
        timestamp
      }
      metaData {
        lineId
        lineName
      }
      subTitle
      title
      systemInfo
      type
    }
  }
`;
